// Add type declarations for Google Analytics
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export const trackEvent = (
    category: string,
    action: string,
    label?: string,
    value?: number
  ) => {
    if ('gtag' in window) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value
      });
    }
  };
  
  export const trackPageView = (path: string) => {
    if ('gtag' in window) {
      window.gtag('config', 'G-GVE2K9NN21', {
        page_path: path,
        defer: true
      });
    }
  };
  
  export const loadGoogleAnalytics = () => {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-GVE2K9NN21';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]){window.dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', 'G-GVE2K9NN21');
  };